// eslint-disable-next-line no-unused-vars
import { h, Component } from 'preact';
import PropTypes from 'prop-types';
import FieldDropdown from './FieldDropdown';
import {
  incrementFilter,
  setList,
  setSort,
} from '../../../../stores/Filters/UsedVehicles/FilterV3';

class OrderFilter extends Component {
  constructor(props) {
    super(props);

    const defaultSortOption = this.props.defaultSort
      ? this.props.sortOptions.find(option =>
          this.props.defaultSort.includes(option.value),
        )
      : null;

    this.state = {
      sortItem: defaultSortOption || this.props.sortOptions[0],
    };

    this.handleSortChange = this.handleSortChange.bind(this);
  }

  async handleSortChange(sortItem) {
    this.setState(oldState => ({
      ...oldState,
      sortItem,
    }));

    incrementFilter({
      key: 'sort',
      value: sortItem.value,
    });
    setSort(sortItem.value);
    setList();
  }

  render() {
    const { sortOptions } = this.props;
    const { sortItem } = this.state;

    return (
      <div className="filter-v2__sort-field">
        <p className="filter-v2__sort-field-label">Ordenar por</p>
        <FieldDropdown
          fieldTitle={sortItem.label}
          customClasses="sort-select"
          dropdownCustomClasses="sort-select__dropdown"
        >
          <ul className="sort-select__fields-list">
            {sortOptions.length > 0 &&
              sortOptions.map(sortOptionItem => (
                <li
                  key={sortOptionItem.label}
                  className="filter-v2__item"
                  data-is-active={sortItem.value === sortOptionItem.value}
                >
                  <button
                    className="sort-select__option-button"
                    type="button"
                    onClick={() => this.handleSortChange(sortOptionItem)}
                  >
                    {sortOptionItem.label}
                  </button>
                </li>
              ))}
          </ul>
        </FieldDropdown>
      </div>
    );
  }
}

OrderFilter.defaultProps = {
  sortOptions: [
    { label: 'Mais relevante', value: '-featured,-ordination' },
    { label: 'Maior preço', value: '-price' },
    { label: 'Menor preço', value: '+price' },
    { label: 'Marca A-Z', value: '+brand.keyword' },
    { label: 'Marca Z-A', value: '-brand.keyword' },
    { label: 'Modelo A-Z', value: '+name.keyword' },
    { label: 'Modelo Z-A', value: '-name.keyword' },
  ],
  defaultSort: null,
};

OrderFilter.propTypes = {
  sortOptions: PropTypes.arrayOf(),
  defaultSort: PropTypes.string,
};

export default OrderFilter;
